import React from "react";
import clsx from "clsx";
import styles from "./PlanningWeek.module.scss";
import useSwipe from "./useSwipe";

/**
 * The 7 days of a week, like the iOS calendar: swipe to change the week, tap a day to select it.
 * In multi-day mode, the days on screen are highlighted.
 */
const WeekStrip = ({days, selectedKey, visibleKeys, onSelect, onPreviousWeek, onNextWeek}) => {
  const {offset, swiping, handlers} = useSwipe({onSwipeLeft: onNextWeek, onSwipeRight: onPreviousWeek});

  return <div className={styles.weekStrip} {...handlers}>
    <div className={clsx(styles.weekDays, swiping && styles.swiping)}
         style={{transform: "translateX(" + offset + "px)"}}>
      {days.map((day, i) => {
        const visible = visibleKeys?.has(day.key);

        return <button key={day.key}
                       type="button"
                       className={clsx(styles.weekDay, {
                         [styles.selected]: day.key === selectedKey,
                         [styles.visible]: visible,
                         [styles.visibleStart]: visible && !visibleKeys.has(days[i - 1]?.key),
                         [styles.visibleEnd]: visible && !visibleKeys.has(days[i + 1]?.key),
                         [styles.today]: day.isToday,
                         [styles.we]: day.isWeekend
                       })}
                       onClick={() => onSelect(day.key)}>
          <span className={styles.weekDayName}>{day.weekday}</span>
          <span className={styles.weekDayNumber}>{Number(day.dayOfMonth)}</span>
        </button>;
      })}
    </div>
  </div>;
};

export default WeekStrip;
